import { Box, Link, Typography } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import { headList, searchFormList, searchFormSchema } from "./parts";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useNavigate } from "react-router-dom";
import { httpAPI_REC012, httpAPI_REC014, httpAPI_REC019 } from "./api/request";
import { IAPI_REC014_Request, IAPI_REC019_Request } from "../../type/apiType";
import { GlobalContext } from "../../context/globalContext";
import { changeAmountFormat } from "../../utils/useTools";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { BusinessContext } from "../../context/businessContext";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import _ from "lodash";

/**
 * SCRW160010 割増金一覧
 * @return SCRW160010 割増金一覧
 */
const SCRW160010 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [billingList, setBillingList] = useState<any>([]);
  const [dataList, setDataList] = useState<any>();
  const [checkDataList, setCheckDataList] = useState<any>();
  const [checkedBillingDataList, setCheckedBillingDataList] = useState<any>([]); //チェックされているテーブルリスト
  const [open, setOpen] = useState(false);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.paymentManagement?.searchForPremium;

  // 割増金一覧参照API
  const handlePostSurchargesList = async (searchData?: any) => {
    try {
      const res = await httpAPI_REC012(searchData);
      setBillingList([]);
      if (res.resultCd === "I0000") {
        setDataList(res.billingDataList);
        const infoBodyList = res.billingDataList!.map((item) => [
          {
            children: (
              <Link
                data-testid="invoiceIdLink"
                onClick={() =>
                  handleClickInvoiceIdLink(item.invoiceId, searchData)
                }
              >
                {item.invoiceId}
              </Link>
            ),
            forSort: item.invoiceId,
          },
          {
            children:
              (item.billingContractorNo ?? "") +
              ":" +
              (item.billingContractorName ?? ""), //請求先名
            forSort: item.billingContractorNo,
          },
          {
            children: item.depositKbn, //区分
            forSort: item.depositKbn,
          },

          {
            children: changeAmountFormat(item.additionalAmt!),
            align: "right",
            forSort: item.additionalAmt,
          },
        ]);
        setBillingList(infoBodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = searchList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;

      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);

    handlePostSurchargesList(context);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickInvoiceIdLink = (clickedInvoiceId: any, search?: any) => {
    setBusinessState({
      ...businessState,
      job_13: {
        ...businessState.job_13,
        demanderId: clickedInvoiceId,
      },
      job_83: {
        ...businessState.job_83,
        demanderId: clickedInvoiceId,
      },
      paymentManagement: {
        searchForPremium: search,
      },
    });

    navigate("/SCRW160005", { state: { invoiceId: clickedInvoiceId } });
  };

  // 選択
  const handleSelect = (indexArr: number[]) => {
    if (indexArr.length === 0) {
      setCheckedBillingDataList([]);
      setCheckDataList([]);
      return;
    }

    const selectedList = indexArr.map((index) => {
      return billingList[index];
    });
    const checkedList = indexArr.map((index) => {
      return dataList[index];
    });
    setCheckDataList(checkedList);
    setCheckedBillingDataList(selectedList);
  };

  const makeSurchargeObj = () => {
    const makeData = checkDataList.map((item: any) => {
      return { invoiceId: item.invoiceId };
    });
    const makeSurcharge: IAPI_REC014_Request = {
      billingStatusDataList: makeData,
    };
    return makeSurcharge;
  };

  const makeRegisterObj = () => {
    const makeData = checkDataList.map((item: any) => {
      return {
        invoiceId: item.invoiceId,
        billingContractorNo: item.billingContractorNo,
      };
    });
    const makeRegister: IAPI_REC019_Request = {
      surchargesDataList: makeData,
    };
    return makeRegister;
  };

  const handleOk = async () => {
    // 割増金要処理一覧更新API
    const makeObj = makeRegisterObj();
    try {
      const res = await httpAPI_REC019({ ...makeObj });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 請求しないボタン押下時
  const handleNoCharge = async () => {
    // 割増金請求状態更新API
    const makeObj = makeSurchargeObj();
    try {
      const res = await httpAPI_REC014({ ...makeObj });
      if (res.resultCd === "I0000") {
        setBillingList([]);
        setCheckDataList([]);
        setCheckedBillingDataList([]);
        setDataList([]);
        handlePostSurchargesList();
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //要処理一覧に登録
  const handleRegisterOnList = () => {
    setOpen(true);
  };

  return (
    <Box className="SCRW160010" data-testid="SCRW160010PageForTest">
      <Box className="searchArea">
        <TkSearchForm
          listData={stateSearchList}
          ruleSchema={searchFormSchema}
          onSearch={handlePostSurchargesList}
        />
        <Typography>
          {"対象件数：" + (billingList.length ?? 0) + "件"}
        </Typography>
      </Box>

      <TkDataTable
        headList={headList}
        bodyList={billingList}
        checkSection
        showUnit
        pagin
        useScroll
        onCheckSectionWidth={handleSelect}
      />

      <Box className="buttonGroup">
        <TkBackButton />
        <TkButton
          onClick={() => {
            handleNoCharge();
          }}
          disabled={checkedBillingDataList.length === 0}
        >
          請求しない
        </TkButton>
        <TkButton
          onClick={() => {
            handleRegisterOnList();
          }}
          disabled={checkedBillingDataList.length === 0}
        >
          要処理一覧に登録
        </TkButton>
      </Box>
      <TkMessageDialog
        open={open}
        onOky={handleOk}
        onCancel={() => setOpen(false)}
        title="確認（要処理一覧へ登録）"
        contextText="　選択項目を要処理一覧へ登録します。問題ないでしょうか。"
        cancelText="戻る"
        okText="登録"
      />
    </Box>
  );
};

export default SCRW160010;
